import * as z from 'zod'

export const bridgeSchema = z
  .object({
    event_name: z.string(),
  })
  .catchall(z.any())
